import { useTranslation } from 'react-i18next';

interface Props {
  distance: number;
  unit: 'kilometer' | 'meter';
}

export function Distance({ distance, unit }: Props) {
  const { i18n } = useTranslation();

  if (distance === undefined) {
    return false;
  }

  return distance.toLocaleString(i18n.resolvedLanguage, {
    style: 'unit',
    unit: unit,
    unitDisplay: 'short',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}
